module.exports = __webpack_public_path__ + "static/img/img4.3ebec5e8.png";